import React, { ReactElement } from 'react';
import { IIconProps } from '@cars4ever/public-ui';

const ServerDownIcon = (props: IIconProps): ReactElement => (
  <svg
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 27.5C0 12.3122 12.3122 0 27.5 0C42.6878 0 55 12.3122 55 27.5V28.5C55 43.6878 42.6878 56 27.5 56C12.3122 56 0 43.6878 0 28.5V27.5Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.9954 20H18.9993C17.3397 20 16 21.34 16 23C16 24.66 17.3397 26 18.9993 26H28.467L29.8366 23.77C30.4665 22.69 31.6862 22 32.9958 22C34.3055 22 35.5252 22.69 36.1851 23.81L37.0349 25.19C37.6247 24.65 37.9946 23.87 37.9946 23C37.9946 21.34 36.655 20 34.9954 20ZM18.9993 24C18.4494 24 17.9995 23.55 17.9995 23C17.9995 22.45 18.4494 22 18.9993 22C19.5491 22 19.999 22.45 19.999 23C19.999 23.55 19.5491 24 18.9993 24ZM22.9983 24C22.4484 24 21.9985 23.55 21.9985 23C21.9985 22.45 22.4484 22 22.9983 22C23.5482 22 23.998 22.45 23.998 23C23.998 23.55 23.5482 24 22.9983 24ZM39.7382 33.406L34.4595 24.827C34.1586 24.317 33.5987 24 32.9958 24C32.393 24 31.8331 24.317 31.5402 24.815L26.2705 33.38C25.5457 34.453 26.3265 36 27.7091 36H38.2825C39.6812 36 40.431 34.426 39.7382 33.406ZM32.9958 34.5C32.444 34.5 31.9961 34.052 31.9961 33.5C31.9961 32.948 32.444 32.5 32.9958 32.5C33.5477 32.5 33.9956 32.948 33.9956 33.5C33.9956 34.052 33.5477 34.5 32.9958 34.5ZM33.9956 30.5C33.9956 31.052 33.5487 31.5 32.9958 31.5C32.443 31.5 31.9961 31.052 31.9961 30.5V27.5C31.9961 26.948 32.443 26.5 32.9958 26.5C33.5487 26.5 33.9956 26.948 33.9956 27.5V30.5ZM16 31C16 29.34 17.3397 28 18.9993 28H27.2373L24.6179 32.26C24.268 32.78 24.058 33.37 24.018 34H18.9993C17.3397 34 16 32.66 16 31ZM17.9995 31C17.9995 31.55 18.4494 32 18.9993 32C19.5491 32 19.999 31.55 19.999 31C19.999 30.45 19.5491 30 18.9993 30C18.4494 30 17.9995 30.45 17.9995 31ZM21.9985 31C21.9985 31.55 22.4484 32 22.9983 32C23.5482 32 23.998 31.55 23.998 31C23.998 30.45 23.5482 30 22.9983 30C22.4484 30 21.9985 30.45 21.9985 31Z"
      fill="#767676"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="27.5"
        y1="0"
        x2="27.5"
        y2="56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBEBEB"/>
        <stop
          offset="1"
          stopColor="white"
        />
      </linearGradient>
    </defs>
  </svg>

);

export default ServerDownIcon;
